var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompetence(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44.7 68.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#fff;stroke-width:4px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "competence") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M998.44-315.62c.1-2.36-1.37-8.67-.92-10.59,1.29-5.48,13.78-10,10.81-19.08-2.25.54-1,3.53-3.91,4.05-3.07.56-4.26.25-11.64,1.57-2-1.3-3.56-3.28-3.36-4.9.31-2.43,4.28-3.39,6.35-5.67a25.17,25.17,0,0,0,5.32-10.62c3.44,1.86,8.62,1.92,11.7,2.57,16,3.37,16.32,31,9.4,42.84Zm24.74,1.65a15.18,15.18,0,0,1,2.85,5.69c.58,3.34-2.73,5.71-1.49,7.17a19.58,19.58,0,0,1,1.37,2.32c-1.9,1.37-11.94,1.29-15.25,1.27a86.21,86.21,0,0,1-14.31-1",
    transform: "translate(-987.41 363.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M996-298.57c-2.47-.57,1-2.57,1-3.16.13-1.39-2.35-4.33-2-7.12.23-1.74,1.67-2.92,2.44-4.77",
    transform: "translate(-987.41 363.8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompetence);
export default __webpack_public_path__ + "static/media/competence.a80c06cc.svg";
export { ForwardRef as ReactComponent };